import React from 'react';
import './App.less';
import BasicRoute from './Router/Router'
import { ConfigProvider} from 'antd';

function App() {
  return <div className='App'>
    <ConfigProvider
      theme={{
        "token": {
          "colorPrimary": "#EE3172",
          "colorInfo": "#EE3172",
          lineHeight: 1
        },
        components: {
          Menu: {
            itemHeight: 40,
            activeBarHeight: 2,
            activeBarBorderWidth: 2,
            itemSelectedColor: '#EE3172',
            itemHoverColor: '#EE3172',
            horizontalItemSelectedColor: '#EE3172',
          }
        }
      }}
    >
      <BasicRoute />
    </ConfigProvider>
  </div>
}

export default App;

